import { Link } from 'react-router-dom'
import { Film, Mail, Github, Twitter } from 'lucide-react'

export default function Footer() {
  return (
    <footer className="bg-dark-800/50 border-t border-dark-700/50 mt-auto">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <Film className="w-7 h-7 text-primary-500" />
              <span className="text-xl font-black tracking-tight">
                <span className="text-primary-500">IC</span>
                <span className="text-white">LIX</span>
              </span>
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed">
              Platform streaming gratis tanpa batas. Film, series, anime & live TV.
            </p>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">Navigasi</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-400 hover:text-white text-sm transition-colors">Beranda</Link></li>
              <li><Link to="/trending" className="text-gray-400 hover:text-white text-sm transition-colors">Trending</Link></li>
              <li><Link to="/genre/action" className="text-gray-400 hover:text-white text-sm transition-colors">Genre</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">Dukungan</h4>
            <ul className="space-y-2">
              <li><a href="#" className="text-gray-400 hover:text-white text-sm transition-colors">Bantuan</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white text-sm transition-colors">Kontak</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white text-sm transition-colors">Laporan Konten</a></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">Hukum</h4>
            <ul className="space-y-2">
              <li><a href="#" className="text-gray-400 hover:text-white text-sm transition-colors">Ketentuan Layanan</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white text-sm transition-colors">Kebijakan Privasi</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white text-sm transition-colors">DMCA</a></li>
            </ul>
          </div>
        </div>
        <div className="mt-10 pt-8 border-t border-dark-700 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-gray-500 text-sm">© 2025 ICLIX. Dibuat dengan React + Supabase + Cloudflare.</p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-gray-400 hover:text-white transition-colors"><Twitter className="w-5 h-5" /></a>
            <a href="#" className="text-gray-400 hover:text-white transition-colors"><Github className="w-5 h-5" /></a>
            <a href="mailto:hi@iclix.web.id" className="text-gray-400 hover:text-white transition-colors"><Mail className="w-5 h-5" /></a>
          </div>
        </div>
      </div>
    </footer>
  )
}
